import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createSvgIcon, createTheme, css, CssBaseline, GlobalStyles, ThemeProvider } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import {CookiesProvider} from "react-cookie";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);



const CheckboxActiveIcon = createSvgIcon(
  <svg width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="4.5" width="14" height="14" rx="2.5" stroke="#126DF7"/>
    <path d="M4 9.5L6.30153 12.8085C6.70159 13.3835 7.55367 13.3797 7.94849 12.801L16 1" stroke="#126DF7"/>
  </svg>,
  ''
);

const CheckboxIcon = createSvgIcon(
  <svg width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="4.5" width="14" height="14" rx="2.5" stroke="#126DF7"/>
  </svg>,
  ''
);


const theme = createTheme({
  typography: {
    fontFamily: "Montserrat",
    h1: {
      fontFamily: "Montserrat",
      color: "#262626",
      fontSize: "20px",
      fontWeight: 700,
      lineHeight: "24.38px"
    },

    body2: {
      fontFamily: "Montserrat",
      color: "#7D7D7D",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "21.28px"
    },

    body1: {
      fontFamily: "Montserrat",
      color: "#262626",
      fontSize: "15px",
      fontWeight: 400,
      lineHeight: "22.28px"
    }
  },

  components: {
    MuiCheckbox: {
      defaultProps: {
        icon: <CheckboxIcon sx={{ margin: "-4px -2px 0 0" }} />,
        checkedIcon: <CheckboxActiveIcon sx={{ margin: "-4px -2px 0 0" }} />,
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: "15px",
          boxShadow: "0px 0px 15px 0px #0000001A"
        }
      }
    },

    MuiLink: {
      defaultProps: {
        underline: "none"
      }
    },

    MuiButton: {
      defaultProps: {
        variant: "contained",
      },

      styleOverrides: {
        root: {
          whiteSpace: "nowrap",
          textTransform: "none",
          boxShadow: "none"
        },

        sizeLarge: css`
          white-space: nowrap;
          box-shadow: none;
          border-radius: 10px;
          height: 48px;
        `
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          display: "flex",
          alignItems: "center",
          borderRadius: "10px",

          '& .MuiOutlinedInput-notchedOutline': {
            transition: "all 250ms ease-in-out",
            borderColor: '#126DF736', // Default border color
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#126DF7', // Hover border color
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#126DF7', // Focused border color
          },
        },
      },
    },
  },

  palette: {
    primary: {
      main: '#126DF7'
    },

    background: {
      default: '#f00'
    }
  }
});

root.render(
  <React.StrictMode>
    <CookiesProvider defaultSetOptions={{ path: '/' }}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles styles={css`body { background-color: #fafafa; margin: 0; } a { color: inherit; text-decoration: none; } }`} />
      
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
    </CookiesProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
